import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MeasurementService} from '../../services/measurement.service';
import {Subscription} from 'rxjs';
import 'rxjs-compat/add/observable/of';
import {MeasurementDetailsSummary} from '../../entities/MeasurementDetailsSummary';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthService} from '../../services/auth.service';
import {NavigationService} from '../../services/navigation.service';

const DIAGNOSIS_PATH = '/diagnosis/diagnosis.html?measurement_id=';


@Component({
  selector: 'app-measurement',
  templateUrl: './measurement.component.html',
  styleUrls: ['./measurement.component.scss']
})
export class MeasurementComponent implements OnInit, OnDestroy {

  measurementId: string;
  username: string;

  detailsSummary: MeasurementDetailsSummary;

  subs: Array<Subscription> = [];
  diagnosisUrl: string = null;

  constructor(
      private route: ActivatedRoute,
      private measurementService: MeasurementService,
      private sanitizer: DomSanitizer,
      private authService: AuthService,
      private navigationService: NavigationService
  ) {}

  iframeHeight: number = 1400;
  commentDisplay: string | null = "";

  ngOnInit() {
    const sub: Subscription = this.route.params
        .switchMap(params => {
          const id: string = params['id']; // measurement identifier is a string !
          this.measurementId = id;
          const gUrl = this.urlForId(DIAGNOSIS_PATH, id, this.authService.getCurrentUser().token);
          this.diagnosisUrl = this.sanitizer.bypassSecurityTrustResourceUrl(gUrl) as string;
          return this.measurementService.getMeasurementDetails(id);
        })
        .subscribe(summary => {
            this.detailsSummary = summary;
        });
    this.subs.push(sub);
        window.addEventListener('message', (event) => {
          if (typeof event.data === 'object' && event.data.Height) {
            this.iframeHeight = event.data.Height;
          } else {
            this.iframeHeight = 1400;
          }
          if (typeof event.data === 'object' && event.data.Comment) {
            this.commentDisplay = event.data.Comment;
          } else {
            this.commentDisplay = "";
          }
        });
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
    this.subs = [];
  }

  /**
   * Calculate the url for the backend.
   * If run local with port 4200, then map to port 3000 for rails development server  
   * @param backendPath backend path ends with '?measurement_id='
   * @param measurementId measurement id
   * @param token authentication token (JWT)
   */
  urlForId(backendPath: string, measurementId: string, token): string {
    const location = window.location;
    return location.protocol + '//' +
        location.hostname +
        (location.port ? ':3000' : '') +
        backendPath + measurementId + '&token=' + token +
        '&use_same_host=true&t=' + new Date().getTime(); // add timestamp to avoid caching
  }



  goBacktopatient(): void {
    this.navigationService.Back();
  }
}
